import { BehaviorSubject, Observable } from 'rxjs';

export class ContractUtils {
  private static excludedContractsSubject = new BehaviorSubject<Array<string>>(
    []
  );
  private static cancelledContractsSubject = new BehaviorSubject<Array<string>>(
    []
  );

  // Adicionando para contratos simplesmente removidos
  private static removedContractsSubject = new BehaviorSubject<Array<string>>(
    []
  );

  static excludedContracts$: Observable<Array<string>> =
    this.excludedContractsSubject.asObservable();
  static cancelledContracts$: Observable<Array<string>> =
    this.cancelledContractsSubject.asObservable();
  static removedContracts$: Observable<Array<string>> =
    this.removedContractsSubject.asObservable();

  static addExcludedContract(contractId: string): void {
    const current = this.excludedContractsSubject.value;
    if (!current.includes(contractId)) {
      const updated = [...current, contractId];
      this.excludedContractsSubject.next(updated);
    }
  }

  static addCancelledContract(contractId: string): void {
    const current = this.cancelledContractsSubject.value;
    if (!current.includes(contractId)) {
      const updated = [...current, contractId];
      this.cancelledContractsSubject.next(updated);
    }
  }

  static addRemovedContract(contractId: string): void {
    const current = this.removedContractsSubject.value;
    if (!current.includes(contractId)) {
      const updated = [...current, contractId];
      this.removedContractsSubject.next(updated);
    }
  }

  static getExcludedContracts(): Array<string> {
    return [...this.excludedContractsSubject.value];
  }

  static getCancelledContracts(): Array<string> {
    return [...this.cancelledContractsSubject.value];
  }

  static getRemovedContracts(): Array<string> {
    return [...this.removedContractsSubject.value];
  }

  static reset(): void {
    this.excludedContractsSubject.next([]);
    this.cancelledContractsSubject.next([]);
    this.removedContractsSubject.next([]);
  }
}
